import { useQuery } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { OffboardingCategory } from "@oysterhr/schema"

export const PARENT_OFFBOARDING_CATEGORIES = gql`
  query parentOffboardingCategories($admin: Boolean!, $globalPayroll: Boolean!) {
    parentOffboardingCategories(admin: $admin, globalPayroll: $globalPayroll) {
      id
      name
      minimumOffboardingDays
      specialCategoryType
      publicSecondaryCategories {
        id
        name
      }
      secondaryOffboardingCategories {
        id
        name
      }
    }
  }
`

export const usePrimaryCategory = (admin: boolean, globalPayroll: boolean) =>
  useQuery<{ parentOffboardingCategories: OffboardingCategory[] }>(PARENT_OFFBOARDING_CATEGORIES, {
    variables: { admin: admin, globalPayroll: globalPayroll },
  })
